import React from "react";

const MobileAddButton = props => {
  return (
    <button
      className="btn btn-danger btn-lg"
      value={"add"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileAddButton;
